export default __webpack_public_path__ + "static/media/exclusive-cartel-district.70851400.png";